<template>
  <div class="otj-progress">
    <span>Overall OTJ Progress:
      <span v-if="totalTimeSpent" class="total-time-spent">
        {{ formatTimeSpent(totalTimeSpent) }}
      </span>
      <span v-else>0h</span>
    </span>
    <span v-if="plannedOtjHours !== null" class="planned-time">
      / {{ plannedOtjHours }}h<br>
    </span>
  </div>
</template>

<style scoped>
.otj-progress {
  color: var(--kate-type-primary);
}

.total-time-spent {
  color: var(--kate-type-primary);
  font-family: hk-grotesk-semibold, sans-serif;
}
</style>

<script>
import TimeMixin from '@mixins/time-mixins';

export default {
  mixins: [TimeMixin],

  props: {
    totalTimeSpent: {
      type: Number,
    },
    plannedOtjHours: {
      type: Number,
      default: null,
    },
  },
};
</script>
